import "../../ChartBrand.css";
import "./ChartTooltip.css";

import { CSSProperties, ReactNode } from "react";

import { useChartVariant } from "../../ChartVariantContext";
import { ChartVariant, getChartTheme } from "../../utils";

interface ChartTooltipProps {
  children: ReactNode;
  /** Positioning modifier — `"AtPointer"` for a segment, `"AboveLabel"` for a cut name. */
  placement: "AtPointer" | "AboveLabel";
  /**
   * The chart's resolved brand. Pass it whenever the chart resolved one itself — an
   * explicit `variant` on PieChart beats the provider, and re-reading the context here
   * would quietly put Hub chrome on a Seed chart.
   */
  variant?: ChartVariant;
  style?: CSSProperties;
}

/**
 * The chart's tooltip. Square for Hub, rounded for Seed, in the variant's typeface —
 * the chrome the canvas tooltip used to take from Chart.js, now that it is DOM.
 */
export const ChartTooltip = ({ children, placement, variant, style }: ChartTooltipProps): JSX.Element => {
  const contextVariant = useChartVariant();
  const theme = getChartTheme(variant ?? contextVariant);

  return (
    <div
      className={`ChartTooltip ChartBrand_${theme.variant} ${placement}`}
      style={{ borderRadius: theme.tooltipCornerRadius, ...style }}
    >
      {children}
    </div>
  );
};
